import React, { useEffect } from "react"
import { StaticQuery, graphql } from "gatsby"

import { withMicrocopy } from "~contexts/MicrocopyContext"
import Sidebar from "./Sidebar"

export const Component = ({ className, microcopy, location }) => (
  <StaticQuery
    query={query}
    render={(data) => (
      <Sidebar
        className={className}
        microcopy={microcopy}
        location={location}
        tags={data.tags.nodes}
        deprecatedTags={data.deprecatedTags.nodes}
        resources={data.resources.nodes}
      />
    )}
  />
)

export const query = graphql`
  query {
    tags: allTag(
      sort: { name: ASC }
      filter: { deprecated: { ne: true } }
    ) {
      nodes {
        id
        key
        name
        isBeta
        version
        deprecated
        resources {
          id
          key
          path
          title
          version
        }
        endpoints {
          id
          key
          path
          title
          verb
          stabilityLevel
          version
        }
      }
    }
    deprecatedTags: allTag(
      sort: { name: ASC }
      filter: { deprecated: { eq: true } }
    ) {
      nodes {
        id
        key
        name
        version
        deprecated
        resources {
          id
          key
          path
          title
          version
        }
        endpoints {
          id
          key
          path
          title
          verb
          version
        }
      }
    }
    resources: allResource(
      filter: { hide: { eq: false } }
    ) {
      nodes {
        id
        key
        path
        title
        version
      }
    }
  }
`

export default withMicrocopy(Component)
